$(function () {
  const $input = $(".contributor-search-input")
  $input.select2({
    ajax: {
      url: '/curators/users/search',
      data: function (params) {
        return {
          query: params.term
        }
      },
      dataType: 'json',
      delay: 500,
      processResults: function (data, params) {
        const useQuery = $input.data('contributor-result-type') === "query"
        return {
          results: data.data.map(el => {
            return {
              text: `${el.attributes.first_name} ${el.attributes.last_name} / ${el.attributes.company_name}`,
              id: useQuery ? `${el.attributes.first_name} ${el.attributes.last_name}` : el.id
            }
          })
        }
      },
      cache: true
    }
  }).on('change', function () {
    $(this).closest('form').submit()
  })

  $(".contributor-search-input-field").select2({
    ajax: {
      url: '/curators/users/search',
      data: function (params) {
        return {
          query: params.term
        }
      },
      dataType: 'json',
      delay: 500,
      processResults: function (data, params) {
        return {

          results: data.data.map(el => {
            return {
              text: `${el.attributes.first_name} ${el.attributes.last_name} / ${el.attributes.company_name}`,
              id: el.id
            }
          })
        }
      },
      cache: true
    }
  })
});

$(document).on("turbolinks:before-cache", function() {
  $(".contributor-search-input-field").select2('destroy');
  $(".contributor-search-input").select2('destroy');
})